module.exports = __webpack_public_path__ + "static/casablanca-bg-1200x600-781b92690bdf50f4bf78c90f6541b2bd.jpg";